const initialState = {
  cart: [],
  instalmentSelections: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'ADD_TO_CART': {
      return { ...state, cart: action.payload.id };
    }
    case 'SET_INSTALMENT_SELECTION': {
      return {
        ...state,
        instalmentSelections: {
          ...state.instalmentSelections,
          [action.payload.productId]: action.payload.selectedInstalments,
        },
      };
    }
    case 'REMOVE_FROM_CART': {
      let cart = state.cart;
      const newSelections = { ...state.instalmentSelections };
      delete newSelections[action.payload.id];
      return { ...state, cart: cart.filter(id => id !== action.payload.id), instalmentSelections: newSelections }
    }
    case 'EMPTY_CART': {
      return { ...state, cart: [], instalmentSelections: {} };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
